import { Pipe, PipeTransform } from '@angular/core';

import { ModelStatus } from '../../viewmodels/model-status';


@Pipe({
  name: 'modelStatus',
})
export class ModelStatusPipe implements PipeTransform {

  transform(value: ModelStatus, args?: any): string {
    return ModelStatus[value];
  }

}
